import React, { useState, useEffect } from 'react';

export interface ToastProps {
  message: string | { message: string; [key: string]: any };
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ 
  message, 
  type = 'info', 
  duration = 5000, 
  onClose 
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onClose(), 300); // Animation için
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const handleClose = (): void => {
    setIsVisible(false);
    setTimeout(() => onClose(), 300);
  };

  const getIcon = (): string => {
    switch (type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'warning': return '⚠️';
      case 'info': return 'ℹ️';
      default: return 'ℹ️';
    }
  };

  const getMessage = (): string => {
    if (typeof message === 'object' && 'message' in message && message.message) {
      return message.message;
    }
    return message as string;
  };

  return (
    <div className={`toast toast-${type} ${isVisible ? 'toast-visible' : 'toast-hidden'}`}>
      <div className="toast-content">
        <div className="toast-icon">{getIcon()}</div>
        <div className="toast-message">{getMessage()}</div>
        <button 
          className="toast-close"
          onClick={handleClose}
          aria-label="Kapat"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;